import $ from "jquery";
import autocomplete from "jquery-ui/ui/widgets/autocomplete";

var ruian = {

	geocodeApiUrl: ROOT + "?page=ruian",

	lastData: {},

	init: function () {
		var $this = this;

		$("#billingAddress_street").autocomplete({
			source: function (request, response) {
				$this.autocomplete(request, response);
			},
			focus: function( event, ui ) {
				var key = ui.item.value;
				var data = $this.lastData[key];

				$("#billingAddress_street").val(data.ulice + ' ' + data.cp);
				$("#billingAddress_city").val(data.obec.nazev);
				$("#billingAddress_zip").val(data.psc);
			},
			select: function( event, ui ) {
				event.preventDefault()
				var key = ui.item.value;
				var data = $this.lastData[key];

				var street = data.ulice + ' ' + data.cp
				if(data.co !== '' && data.co != 0) {
					street = street + '/' + data.co;
				}
				$("#billingAddress_street").val(street);
				$("#billingAddress_city").val(data.obec.nazev);
				$("#billingAddress_zip").val(data.psc);
			},
			search: function( event, ui ) {
				$("#billingAddress_city").val('');
				$("#billingAddress_zip").val('');
			}
		});
		$("#billingAddress_street").attr('autocomplete', 'RUIAN-street');

		$("#shippingAddress_street").autocomplete({
			source: function (request, response) {
				$this.autocomplete(request, response);
			},
			focus: function( event, ui ) {
				var key = ui.item.value;
				var data = $this.lastData[key];

				$("#shippingAddress_street").val(data.ulice + ' ' + data.cp);
				$("#shippingAddress_city").val(data.obec.nazev);
				$("#shippingAddress_zip").val(data.psc);
			},
			select: function( event, ui ) {
				event.preventDefault()
				var key = ui.item.value;
				var data = $this.lastData[key];

				var street = data.ulice + ' ' + data.cp
				if(data.co !== '' && data.co != 0) {
					street = street + '/' + data.co;
				}
				$("#shippingAddress_street").val(street);
				$("#shippingAddress_city").val(data.obec.nazev);
				$("#shippingAddress_zip").val(data.psc);
			},
			search: function( event, ui ) {
				$("#shippingAddress_city").val('');
				$("#shippingAddress_zip").val('');
			}
		});
		$("#shippingAddress_street").attr('autocomplete', 'RUIAN-street');
	},

	autocomplete: function (request, response) {
		var $this = this;
		this.fulltextSearch(request.term).done(function (data) {
			$this.lastData = data;
			var result = [];
			for (const [key, place] of Object.entries(data)) {
				var text = place.ulice + ' ' + place.cp;
				if(place.co !== '' && place.co != 0) {
					text = text + '/' + place.co;
				}
				text = text + ', ' + place.obec.nazev + ' ' + place.psc;
				result.push({
					value: key,
					label: text
				});
			}
			response(result);
		});
	},

	fulltextSearch: function (searchText) {
		var request = {
			'query': searchText
		};

		return this.request(request);
	},

	request: function (request) {
		return $.ajax(this.geocodeApiUrl, {
			data: request,
			dataType: "json"
		}).fail(function (jqXHR, textStatus, errorThrown) {
			console.log(jqXHR, textStatus, errorThrown);
		});
	}

};

$(function (){
	ruian.init();
});